export default __webpack_public_path__ + "static/media/SEO-Header.e42382dd.png";